import React, {createContext, useEffect, useState} from 'react';
import {getPortalCompany, getPortalCompanyBySubdomain} from "../app/common/api/WebApi";
import {CONSTANTS} from "../app/common/constants";
import {getCookie} from "../app/common/appCookie";

export const CompanyContext = createContext({
  company: {},
  displayLocation: '',
  refreshContext: true,
  timeZone: ''
});

export const CompanyProvider = (props) => {
  const [companyReady, setCompanyReady] = useState(false);
  const [timeZone, setTimeZone] = useState('');
  const [context, setContext] = useState({
    company: {},
    subdomain: props?.subdomain,
    displayLocation: '',
    refreshContext: true,
    timeZone:''
  });

  const getDisplayLocation = (company) => {
    return `${company?.address1}, ${company.city}`
  }

  const [refreshLocal, setRefreshLocal] = useState(1);

  const handleResponse = (resp) => {
    let _resp = {...resp};
    let displayLocation = getDisplayLocation(resp);
    setContext({...context, company: _resp, displayLocation: displayLocation, refreshContext: false, timeZone:_resp?.timeZone?.timeZoneName});
    setCompanyReady(true);
  }

  useEffect(() => {
    if (!companyReady || context.refreshContext || (refreshLocal && refreshLocal < 25)) {
      if (!getCookie(CONSTANTS.PSB_CID)?.length) {
        const timer = setTimeout(() => {
          setRefreshLocal(refreshLocal + 1)
        }, 1000);
        // Cleanup function to clear the timeout when the component unmounts
        return () => clearTimeout(timer);
        return;
      }

      if (props?.subdomain) {
        getPortalCompanyBySubdomain(props.subdomain).then(resp => {
          handleResponse(resp);
        });
      } else {
        getPortalCompany().then(resp => {
          handleResponse(resp);
        });
      }

    }
  }, [context.refreshContext, refreshLocal, companyReady]);

  return (
    <CompanyContext.Provider value={[context, setContext]}>
        {props.children}
    </CompanyContext.Provider>
  )
}